var React = require('react');

function IconRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.9911 35.8839C20.503 35.3957 20.503 34.6043 20.9911 34.1161L30.7322 24.375L20.9911 14.6339C20.503 14.1457 20.503 13.3543 20.9911 12.8661C21.4793 12.378 22.2707 12.378 22.7589 12.8661L33.3839 23.4911C33.872 23.9793 33.872 24.7707 33.3839 25.2589L22.7589 35.8839C22.2707 36.372 21.4793 36.372 20.9911 35.8839Z"}));
}

IconRight.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = IconRight;

IconRight.default = IconRight;
